/**
 * utils/timezoneUtils.ts
 * Utility functions for handling timezones securely and consistently.
 */

/**
 * Returns a local ISO string (mocking UTC timezone) reflecting the exact local date/time of the device.
 * This ensures that if it's 23:00 local time, the string will say 23:00Z and be saved as the correct day
 * instead of rolling over to the next day due to UTC offset on the server.
 * Use this for all created_at/updated_at and streak timestamp generation.
 */
export function getLocalISOString(date?: Date | number): string {
    const targetDate = date ? new Date(date) : new Date();
    const tzOffset = targetDate.getTimezoneOffset() * 60000;
    // We subtract the timezone offset to force the UTC representation to mirror the local time
    return new Date(targetDate.getTime() - tzOffset).toISOString().slice(0, -1) + 'Z';
}
